
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class CardItemTitle extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
  }
